import { styled } from '@pata-app/themes';

export const TopFeatureTileContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.core.sizing[0]}px;

  color: ${({ theme }) => theme.core.colors.greyscale.white};
  > * {
    margin: 0;
  }

  svg {
    height: 40px;
    width: 40px;

    fill: ${({ theme }) => theme.core.colors.greyscale.white};
    color: ${({ theme }) => theme.core.colors.greyscale.white};

    margin-bottom: ${({ theme }) => theme.core.sizing[1]}px;
  }
`;
